import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    marginLeft: 20,
    fontSize: 12,
    lineHeight: 1.5,
    ...style.marathi,
  },
  header: {
    marginBottom: 20,
    textAlign: 'center'
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 15,
    textAlign: 'center',
    textDecoration: 'underline',
    ...style.marathi,
  },
  content: {
    marginBottom: 15,
    textAlign: 'justify',
    ...style.marathi,
  },
  boldText: {
    fontWeight: 'bold',
    ...style.marathi,
  },
  signatureSection: {
    marginTop: 40,
    textAlign: 'right',
    marginRight: 100
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    marginTop: 2,
    width: 200,
    marginLeft: 'auto'
  },
  stampPlaceholder: {
    marginTop: 30,
    textAlign: 'left',
    color: '#666'
  }
});

const Pramanpatra = ({ result }) => {
    const toMarathiDigits = str => str.replace(/\d/g, d => '०१२३४५६७८९'[d]);
const retirement = toMarathiDigits(result.dateOfRetirement);
  
  
  
  return(
    <View size="A4" style={styles.page}>
      {/* Header with Title */}
      <View style={styles.header}>
        <Text style={styles.title}>प्रमाणपत्र</Text>
      </View>

      {/* Main Content */}
      <Text style={styles.content}>
        प्रमाणित करण्यात येते की, {result.employeeNameMar}, {result.designationMar}, हे {result.institutionNameMar} या महाविदयालयातून दिनांक {retirement} रोजी नियतवयोमानानुसार सेवानिवृत्त होत आहेत.
      </Text>
      
      <Text style={styles.content}>
        मा. विभागीय सहसंचालक, उच्च शिक्षण अनुदान {result.regionMar}, {result.regionalPlaceMar} यांचे अनुदान निर्धारण व मा. लेखाधिकारी, उच्च शिक्षण अनुदान, कोल्हापूर विभाग, कोल्हापूर यांचे कडील लेखापरीक्षण अहवाल यामध्ये संबधितांची कोणतीही वसूली प्रलंबीत नाही. यांचेकडे कोणतेही शासकीय येणे नाही.
      </Text>

      {/* Stamp Placeholder */}
      <Text style={styles.stampPlaceholder}>
        (महाविद्यालयीन शिक्का व दिनांक)
      </Text>

      {/* Signature Section */}
      <View style={styles.signatureSection}>
        <Text>प्राचार्य</Text>
      </View>
    </View>

);
};
export default Pramanpatra;